import { FormattedMessage } from "react-intl";
import {
  Note as NoteType,
  UserTextRecord,
} from "../../../../models/ecg.interface";
import DateTime from "../../../Shared/DateTime/DateTime";
import FindingsIcon from "../../../Shared/FindingsIcon/FindingsIcon";
import MetaCard from "../MetaCard/MetaCard";
import { v4 as uuidv4 } from "uuid";
import TextDirAligner from "../../../Shared/TextDirAligner/TextDirAligner";

type NotesProps = {
  notes: NoteType[];
  compare?: boolean;
};

const Note = (note: UserTextRecord) => (
  <div className="mt-2 d-flex align-items-start">
    <FindingsIcon className="mt-1" selected />
    <div className="mx-1"></div>
    <div>
      <TextDirAligner className="mb-1">{note.text}</TextDirAligner>
      <p className="mb-0 muted-color d-flex">
        <DateTime showTime>{note?.date}</DateTime>
        <span className="mx-sm"></span>
        <TextDirAligner variant="span">{note.user.display}</TextDirAligner>
      </p>
    </div>
  </div>
);

const MetaNotes = ({ notes, compare }: NotesProps) => (
  <MetaCard compare={compare}>
    <div className="font-md">
      <p className="mb-0 prim-color-dark font-weight-bold">
        <FormattedMessage
          id="ECG_DETAILS.NOTES_HISTORY"
          defaultMessage="Notes History"
        />
      </p>
      {notes?.map((note) => (
        <Note
          date={note.date}
          text={note.text}
          key={uuidv4()}
          user={note.user}
        />
      ))}
    </div>
  </MetaCard>
);

export default MetaNotes;
